import {
  getPossibleBodyHeight,
  sliceText,
} from '@Components/BigBrowse/BBCalculationsUtils';
import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { VideoPlane } from '@Components/BigBrowse/bb2/meshes2/cards/VideoPlane';
import { Assets } from '@Utils/AssetsStore';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const MultiSectionSectionHero = observer(
  function MultiSectionSectionHero({
    item,
    onClick,
  }: GridCardMeshProps<PlaneTypes.Card_MultiSection_SectionHero>) {
    const videoData = useMemo(
      () =>
        item.data?.sectionModel.heroMedia.items.find(
          (i) => i.mediaType === 'Mp4VideoClip'
        ),
      [item]
    );

    if (videoData) {
      return (
        <VideoPlane
          position={item.worldPosition}
          size={item.size}
          src={videoData.url}
          radius={15}
          sourceSize={{ width: videoData.width, height: videoData.height }}
        />
      );
    }

    const titleProps: CardTextProps = {
      text: item.data?.title ?? '',
      fontSize: 36,
      fontAsset: Assets.Font_Gilroy_Bold,
      anchorX: 'left',
      anchorY: 'bottom',
      textAlign: 'left',
      maxWidth: item.size.width - 40 * 2,
      position: {
        x: -item.size.width / 2 + 40,
        y:
          -item.size.height / 2 +
          40 +
          getPossibleBodyHeight(item.data?.body ?? '', item.data?.title ?? ''),
      },
    };

    const bodyPros: CardTextProps = {
      text: sliceText(item.data?.body, 200) ?? '',
      fontSize: 18,
      fontAsset: Assets.Font_Gilroy_SemiBold,
      color: 'white',
      anchorX: 'left',
      anchorY: 'bottom',
      textAlign: 'left',
      maxWidth: item.size.width - 40 * 2,
      position: {
        x: -item.size.width / 2 + 40,
        y: -item.size.height / 2 + 40,
      },
    };

    return (
      <ProductCardRounded
        uniqueKey={item.key!}
        position={item.worldPosition}
        size={item.size.width}
        imageUrl={item.data?.imageUrl}
        transparencyColor={transparencyColors[item.type]}
        hoverDisabled
        onClick={onClick}
        isViewHero={item.data?.isViewHero}
      >
        <CardText {...titleProps} />
        <CardText {...bodyPros} />
      </ProductCardRounded>
    );
  }
);
